// General CSS
import "mds/css/index.scss";
import "./index.css";

// React-menu CSS
// We only import the core styles. The rest is overwritten in mds/css/_menu.scss
import "@szhsin/react-menu/dist/core.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

import { OverlayProvider } from "overlay-kit";
import { createRoot } from "react-dom/client";
// eslint-disable-next-line no-restricted-imports
import { Provider as ReduxStoreProvider } from "react-redux";
// eslint-disable-next-line no-restricted-imports
import { Slide, ToastContainer } from "react-toastify";

import { Routes } from "./routes";

import { LoggingProvider } from "providers/LoggingProvider";
import { WaffleFlagReadyBoundary } from "providers/WaffleFlagReadyBoundary";
import { store } from "store";
import { BrowserRouter as Router } from "utils/routing";
import { ErrorBoundary } from "worksheets/views/ErrorBoundary";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");
const root = createRoot(rootEl);
root.render(
  // TODO: This ErrorBoundary catches any redux provider related errors. We should log
  // these to rollbar and ensure the user can recover from this.
  <ErrorBoundary minimal>
    <WaffleFlagReadyBoundary>
      <ReduxStoreProvider store={store}>
        {/*
          TODO This error boundary signifies a failure to render the top-level layout, independent of
          the route. It should be indicated to the user that this is not recoverable through navigation.
          We might want to ensure this is logged to rollbar with highest prio/notifications.
        */}
        <ErrorBoundary>
          <LoggingProvider>
            <Router>
              <OverlayProvider>
                <Routes />
              </OverlayProvider>
            </Router>
          </LoggingProvider>
        </ErrorBoundary>
      </ReduxStoreProvider>
      <ToastContainer
        // // We don't want to close toasts in integration tests, as they are quite
        // // flaky for visual tests
        // TODO: This didn't work as expected, so we're falling back to manually expecting/closing toasts
        // in the test runner. Ask Peter if you are trying to get something similar to work.
        // autoClose={isTestEnv ? false : 3000}
        className="toast-container"
        // We limit toasts to two, as it's unlikely that multiple errors are happening independently
        limit={2}
        pauseOnHover={false}
        transition={Slide}
      />
    </WaffleFlagReadyBoundary>
  </ErrorBoundary>,
);
